import { defineComponent as _defineComponent } from 'vue'
import { ref, watch } from "vue";
  import ArrowUpLanding from "@/assets/icons/arrow-up-landing.svg";
  import { useIsDesktop } from "@/features/useIsDesktop";
  import { formatPrice } from "@/helpers/transformation/price";

  interface UpgradeOptionProps {
    _id: string;
    url: string | undefined;
    price: number;
    name: string;
    includedItems?: string[];
    isSelected: boolean;
  }

  
export default /*@__PURE__*/_defineComponent({
  __name: 'UpgradeOption',
  props: {
    _id: {},
    url: {},
    price: {},
    name: {},
    includedItems: {},
    isSelected: { type: Boolean }
  },
  emits: ["update:selected"],
  setup(__props: any, { expose: __expose, emit: __emit }) {
  __expose();

  const props = __props;
  const { isDesktop } = useIsDesktop(990);

  const isEnabled = ref<boolean>(props.isSelected);
  const isExpanded = ref<boolean>(false);

  const emit = __emit;

  watch(
    () => props.isSelected,
    (newValue) => {
      isEnabled.value = newValue;
    },
    { immediate: true }
  );

  const handleToggleEnabled = () => {
    isEnabled.value = !isEnabled.value;
    emit("update:selected", isEnabled.value);
  };

  const handleToggleExpanded = () => {
    isExpanded.value = !isExpanded.value;
  };

const __returned__ = { props, isDesktop, isEnabled, isExpanded, emit, handleToggleEnabled, handleToggleExpanded, ref, watch, get ArrowUpLanding() { return ArrowUpLanding }, get useIsDesktop() { return useIsDesktop }, get formatPrice() { return formatPrice } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})